import {
  Component, computed,
  EventEmitter,
  input,
  Input,
  OnInit,
  Output, signal,
} from "@angular/core";
import { Finishing } from 'src/app/shared-lib/core/settings';
import { AppService } from "../../shared/app.service";

@Component({
  selector: "app-finishing-settings-section",
  templateUrl: "./finishing-settings-section.component.html",
  styleUrls: ["./finishing-settings-section.component.scss"],
  standalone: false
})
export class FinishingSettingsSectionComponent implements OnInit {
  @Input() settings;
  @Input() printProduct;
  @Output() settingSelectedEvent = new EventEmitter();
  @Output() goToGeneralSettingsEvent = new EventEmitter();
  @Output() closeSettingsEvent = new EventEmitter();

  isMobile = input<boolean>(false);
  settingsSectionHeight = input(0);
  settingsConfigTitleHeight = input(0);
  settingsSelectorButtonsHeight = input(0);

  fixedFooterDesktopHeight = signal(0);
  fixedFooterMobileHeight = signal(0);

  scrollHeightSignal = computed(() => {
    const footerHeight = this.isMobile()
      ? this.fixedFooterMobileHeight()
      : this.fixedFooterDesktopHeight();

    // Cálculo base
    const calculated = this.settingsSectionHeight()
      - this.settingsConfigTitleHeight()
      - this.settingsSelectorButtonsHeight()
      - footerHeight;

    return Math.max(0, calculated);
  });

  constructor(public appService: AppService) {
  }

  ngOnInit() {
  }

  settingOptionSelected(event) {
    this.settingSelectedEvent.emit(event);
  }

  goToGeneralSettings() {
    this.goToGeneralSettingsEvent.emit();
  }

  closeSettings() {
    this.closeSettingsEvent.emit();
  }

  protected readonly print = print;
  protected readonly finishing = Finishing;
}
